module.exports = __webpack_public_path__ + "static/img/robot.f3b3591.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/robot.gif
// module id = Lx72
// module chunks = 0